module.exports = __webpack_public_path__ + "static/media/DigiNany for Childrens Events Program.3dc96c61.png";